<template>
  <div
    :class="[
      bem.b(),
      bem.is('selected', isSelected),
      bem.is('disabled', node.disabled)
    ]"
  >
    <div
      :class="[bem.e('content')]"
      :style="{ paddingLeft: `${node.level * 16}px` }"
    >
      <span
        :class="[
          bem.e('expand-icon'),
          { expanded: expanded && !node.isLeaf },
          bem.is('leaf', node.isLeaf)
        ]"
        @click="handleExpand"
      >
        <cms-icon :color="node.isLeaf ? 'transparent' : '#666'" :size="20">
          <Switcher v-if="!isLoading" />
          <Loading v-else />
        </cms-icon>
      </span>
      <cms-checkbox
        v-if="showCheckbox"
        :model-value="checked"
        :disabled="disabled"
        :indeterminte="indeterminte"
        @change="handleCheckChange"
      ></cms-checkbox>
      <span @click="handleSelected" :class="bem.e('label')">
        <cms-tree-node-content :node="node" />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { createNamespace } from '@chenms-zj/utils/create'
import { treeNodeEmitts, treeNodeProps } from './tree'
import Switcher from '@chenms-zj/components/internal-icon/Switcher'
import Loading from '@chenms-zj/components/internal-icon/Loading'
import cmsTreeNodeContent from './tree-node-content'

const bem = createNamespace('tree-node')
const props = defineProps(treeNodeProps)
const emit = defineEmits(treeNodeEmitts)

const handleExpand = () => {
  emit('toggle', props.node)
}

const isLoading = computed(() => {
  return props.loadingKeys?.has(props.node.key)
})

const isSelected = computed(() => {
  return props.selectedKeys.includes(props.node.key)
})

const handleSelected = () => {
  if (props.node.disabled) {
    return
  }
  emit('select', props.node)
}

function handleCheckChange(val:boolean) {
  emit('check', props.node, val)
}


</script>

<style scoped></style>
